// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"arrow-triangle-down"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M17.5 13L12 20.25L6.5 13H10V3H14V13H17.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17.5 13L12 20.25L6.5 13H10V3H14V13H17.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowTriangleDownIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-triangle-down',
    ref,
    icon: element,
  },
));

ArrowTriangleDownIcon.displayName = 'ArrowTriangleDownIcon';

export default ArrowTriangleDownIcon;
